// Environment Configuration
// This file automatically detects the environment and provides the correct URLs

export interface EnvironmentConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  isFirebase: boolean;
  baseUrl: string;
  apiUrl: string;
  appName: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isProduction = process.env.NODE_ENV === 'production';
  
  // Check if we're running on Firebase hosting
  const isFirebase = window.location.hostname.includes('web.app') || 
                    window.location.hostname.includes('firebaseapp.com') ||
                    window.location.hostname.includes('aminepersia-9902f') ||
                    window.location.hostname.includes('farsi-app-8d683') ||
                    window.location.hostname.includes('farsi-app.com') ||
                    window.location.hostname.includes('farsiforfree.com');

  // Determine base URL - always use Firebase hosting URL
  let baseUrl: string;
  if (isFirebase) {
    // Use current Firebase hosting URL
    baseUrl = window.location.origin;
  } else {
    // Fallback for other environments - use production URL
    baseUrl = 'https://aminepersia-9902f.web.app';
  }

  // API URL configuration - use Firebase Functions for both development and production
  let apiUrl: string;
  // Always use Firebase Functions URL since the backend is deployed on Firebase
  apiUrl = 'https://us-central1-aminepersia-9902f.cloudfunctions.net/api';

  return {
    isDevelopment,
    isProduction,
    isFirebase,
    baseUrl,
    apiUrl,
    appName: 'Farsi Learner'
  };
};

export const env = getEnvironmentConfig();

// Log environment info in development
if (env.isDevelopment) {
  console.log('🌍 Environment Configuration:', {
    environment: process.env.NODE_ENV,
    isFirebase: env.isFirebase,
    baseUrl: env.baseUrl,
    apiUrl: env.apiUrl,
    hostname: window.location.hostname
  });
}

// Helper functions
export const getAssetUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${env.baseUrl}/${cleanPath}`;
};

export const getAudioUrl = (path: string): string => {
  return getAssetUrl(`audio/${path}`);
};

export const getVocabularyAudioUrl = (category: string, filename: string): string => {
  return getAudioUrl(`vocabulary/${category}/${filename}`);
};

// Export constants for easy access
export const FIREBASE_URLS = {
  MAIN: 'https://aminepersia-9902f.web.app',
  ALTERNATIVE: 'https://farsi-app-8d683.web.app',
  FARSI_APP: 'https://farsi-app.com',
  FARSI_FOR_FREE: 'https://farsiforfree.com'
} as const;

export default env; 